"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardsMapping = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _makeAsyncCard = require("crm_ui/sidebar/makeAsyncCard");

var _AboutCardTitle = _interopRequireDefault(require("customer-data-sidebar/cards/AboutCard/AboutCardTitle"));

var _gqlConfig = _interopRequireDefault(require("customer-data-sidebar/graphQL/cards/AboutCard/gqlConfig"));

var _getIsUngatedForGraphQL = require("crm_ui/gates/getIsUngatedForGraphQL");

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _CardsAPIConstants = require("crm_ui/sidebar/layouts/CardsAPIConstants");

var _PropertiesCardTitle = _interopRequireDefault(require("crm_ui/profile/sidebar/properties/PropertiesCardTitle"));

var _PropertiesCardContentContainer = _interopRequireDefault(require("crm_ui/profile/sidebar/properties/PropertiesCardContentContainer"));

var _CardsMapping;

var GlobalPropertiesCardConfig = {
  Title: _AboutCardTitle.default,
  Content: (0, _makeAsyncCard.makeAsyncCard)({
    chunkName: 'sidebar-about',
    loader: function loader() {
      return import(
      /* webpackChunkName: "sidebar-about" */
      'crm_ui/profile/sidebar/properties/FavoritePropertiesCardContainer');
    }
  }),
  gqlConfig: (0, _getIsUngatedForGraphQL.getIsUngatedForGraphQL)(_ObjectTypes.default.DEAL) ? _gqlConfig.default : undefined
};
var PropertiesCardConfig = {
  Title: _PropertiesCardTitle.default,
  Content: _PropertiesCardContentContainer.default
};
var CardsMapping = (_CardsMapping = {}, (0, _defineProperty2.default)(_CardsMapping, _CardsAPIConstants.GLOBAL_PROPERTIES_CARD_TYPE, (0, _extends2.default)({}, GlobalPropertiesCardConfig)), (0, _defineProperty2.default)(_CardsMapping, "PROPERTIES", (0, _extends2.default)({}, PropertiesCardConfig)), _CardsMapping);
exports.CardsMapping = CardsMapping;
var _default = [(0, _extends2.default)({}, GlobalPropertiesCardConfig, {
  key: 'Properties'
})];
exports.default = _default;